<div class="flex flex-col px-6 pt-6 gap-3" data-testid="upload-select-patient-dialog">
  <div class="flex items-center justify-between">
    <h1 class="ml-10 headline-small text-primary flex-1 text-center" data-testid="upload-select-patient-title">{{ 'Select patient' | translate }}</h1>
    <button mat-icon-button
      (click)="close()"
      [attr.aria-label]="'Close' | translate"
      data-testid="upload-select-patient-close">
      <mat-icon class="text-on-surface-variant">close</mat-icon>
    </button>
  </div>
  <div class="flex justify-center">
    <p class="body-medium text-on-surface-variant text-center w-[462px]" data-testid="upload-select-patient-description">
      {{ 'File {{fileName}} uploaded. Which patient would you like to assign it to?' | translate:{ fileName: data.fileName } }}
    </p>
  </div>
</div>

<div class="flex-1 overflow-auto px-6 pt-6">
  <app-patient-selector [selectable]="false" (patientSelected)="onPatientSelected($event)" data-testid="upload-select-patient-selector"></app-patient-selector>
</div>

<div class="px-6 pb-6">
  <div class="flex flex-col gap-4 pt-6 w-full">
    <button mat-flat-button color="primary" class="w-full h-12" (click)="continueWithoutPatient()" data-testid="upload-select-patient-continue-button">{{ 'Continue without patient' | translate }}</button>
    <button mat-button class="title-medium text-primary" (click)="openManualPatient()" data-testid="upload-select-patient-manual-button">{{ 'Add patient manually' | translate }}</button>
  </div>
</div>
